<script setup lang="ts">
import { svgIcon } from "@/common/components";

export interface BreadcrumbItemType {
  key: string;
  label: string;
  url?: string;
  external?: boolean;
}

const props = withDefaults(
  defineProps<{
    items: BreadcrumbItemType[];
    active?: string;
    showHome?: boolean;
    urlHome?: string;
    maxLenght?: number;
  }>(),
  {
    maxLenght: 25,
  }
);

function subs(item: string) {
  if (item.length <= props.maxLenght) return item;
  return item.substring(0, props.maxLenght) + "...";
}
</script>

<template>
	<nav class="bradcrumb-simple">
		<ul>
			<template v-if="showHome && urlHome">
				<li>
					<router-link :to="urlHome">
						<svgIcon icon="home-line" size="1.25rem" />
					</router-link>
					<span> / </span>
				</li>
			</template>

			<template v-for="(item, index) in items" :key="index">
				<li>
					<router-link
						v-if="item.url"
						:to="item.url"
						:target="item.external ? '_blank' : '_self'"
						class="link-url"
						:class="{
							active: active === item.key,
						}"
					>
						{{ subs(item.label) }}
					</router-link>
					<span
						v-else
						class="link-active"
						:class="{
							active: active === item.key,
						}"
					>
						{{ subs(item.label) }}
					</span>
					<span v-if="index < items.length - 1" class="separator"> / </span>
				</li>
			</template>
		</ul>
	</nav>
</template>

<style lang="scss" scoped>
.bradcrumb-simple {
  display: flex;
  align-items: center;
  color: var(--text-off);
  font-size: 1rem;

  ul {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0.25rem;

    li {
      display: flex;
      flex-direction: row;
      user-select: none;

      .svg-icon {
        width: 1.25rem;
        height: 12.5rem;
      }

      .link-active {
        color: var(--text-off);
        font-size: 1rem;
        margin-left: 0;
        cursor: default;

        &.active {
          color: var(--text);
          text-decoration: underline;
        }
      }

      .separator {
        margin-inline: 0.5rem;
        color: var(--text-off);
      }

      a {
        color: var(--text-off);
        font-size: 1rem;
        text-decoration: none;

        &:hover {
          color: var(--text);
        }

        &.active {
          color: var(--text);
          text-decoration: underline;
        }
      }

      a.link-url {
        color: var(--text-off);
        font-size: 1rem;
        text-decoration: none;

        &:hover {
          color: var(--text);
          text-decoration: underline;
        }

        &.active {
          color: var(--text);
          text-decoration: underline;
        }
      }

      span {
        font-size: 1rem;
        color: var(--text-off);
        margin-left: 1rem;
        margin-right: 0.75rem;
      }
    }
  }
}
</style>
